module.exports = __webpack_public_path__ + "static/media/girl.e1b10c9b.png";